"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "flex",
    staticStyle: {
      width: "300px",
      "justify-content": "space-between",
      "margin-right": "30px"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c("div", {
      key: item.key,
      staticClass: "quick-btn",
      class: {
        select: _vm.currentQuick === item.key
      },
      on: {
        click: function ($event) {
          return _vm.handleQuickBtnClick(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 0);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;